import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import { userTypeList, localeTw, isType, isTypeBK } from 'main_consts';
import { Iobject } from 'main_type';
import {
  blobDownload,
  getSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  getSample,
  getExcel,
  postSearch,
  postExcel,
} from 'main_api';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import {
  getExpressName,
  getDateDayPlus,
  inputChange,
  getWarehouse,
  initWhrehhouse,
  formatDate,
  getEhuFunctionChk,
  EhuFunctionChkResult,
} from '../../../main_func';
import { Iresult, Imaster, ICRUDDetail, ICRUD } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 貨櫃卸存清單維護 */
const CtnrUnloadListMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'ctnrUnloadListMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [warehouseName, setWarehouseName] = useState('');
  const [randomValue, setRandomValue] = useState(Math.random());
  const [random, setRamdom] = useState(Math.random());

  const masterDefaultValue: Imaster = {
    // 上傳日期
    insertDate: getDateDayPlus(),
    // 貨棧業者
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    // 海關通關號碼
    vesselRegNo: '',
    // 主提單號碼
    mawbNo: '',
    // 貨櫃號碼
    containerNo: '',

    dateValid: true,
    warehouseValid: true,

    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  const [QueryOK, setQueryOK] = useState(false);
  const [enableSave, setEnableSave] = useState<boolean>(false);
  const [enableConfirm, setEnableConfirm] = useState<boolean>(false);

  useEffect(() => {
    getEhuFunctionChk().then((item) => {
      if (
        userType &&
        !(
          isType(userTypeList.admin, userType) ||
          isTypeBK(userType) ||
          isType(userTypeList.topType, userType) ||
          isType(userTypeList.type1, userType) ||
          isType(userTypeList.type4, userType) ||
          isType(userTypeList.type2, userType)
        )
      ) {
        setFormError(true);
        enqueueSnackbar(`您無權限使用此功能!`);
      }
    });
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  function onCellEditingStartedEvent(event: any) {
    // console.log('onCellEditingStarted(local):', event);
    switch (event.colDef.field) {
      case 'declDate':
        // setTimeout(() => {
        //   if (isType(userTypeList.type1, userType)) {
        //     event.api.stopEditing(true);
        //   }
        // }, 0);
        break;
      default:
        break;
    }
  }
  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (): ColDef[] => {
    return [
      {
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '業者',
        field: 'expressName',
        width: 300,
      },
      {
        headerName: '卸存地代碼',
        field: 'warehouse',
        width: 300,
        hide: true,
      },
      {
        headerName: '海關通關號碼',
        field: 'vesselRegNo',
        width: 300,
      },
      {
        headerName: '主提單號碼',
        field: 'mawbNo',
        width: 150,
      },
      {
        headerName: '貨櫃號碼',
        field: 'containerNo',
        width: 150,
      },
      {
        headerName: '上傳時間',
        field: 'uploadDate',
        width: 300,
      },
      {
        headerName: '彙總匯出',
        field: 'downloadFlag',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          if (params && params.data.processDesc === '寫檔成功!') {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs();

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
      onCellEditingStarted: onCellEditingStartedEvent,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      const result = await postSearch(apiName, {
        insertDate: master.insertDate,
        warehouse: master.warehouse,
        vesselRegNo: master.vesselRegNo,
        mawbNo: master.mawbNo,
        containerNo: master.containerNo,
      });
      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      // TODO 確認List名稱
      const { data: dataTemp } = result.data;
      const {
        enableSave: enableSaveTemp,
        unloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          unloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];
      // const data = result.data.data as Iresult[];

      if (data) {
        if ((data || []).length > 0) {
          setEnableSave(enableSaveTemp);

          if (isType(userTypeList.type1, userType)) {
            setEnableConfirm(enableSaveTemp);
          } else {
            setEnableConfirm(false);
          }
          setRowData(data);
          setOpenSearchTable(true);
        } else {
          setEnableSave(false);
          setOpenSearchTable(false);
        }
      } else {
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSample = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));

      const result = await getSample(apiName, '');

      blobDownload(result, enqueueSnackbar, `貨櫃卸存清單上傳格式範本.xlsx`);
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            etaDate: node.data.etaDate,
            warehouse: isType(userTypeList.type1, userType)
              ? node.data.warehouse
              : master.warehouse,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            declDate: node.data.declDate,
            uploadDate: node.data.uploadDate,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }
      const DataCRUD: ICRUD = {
        unloadGoodsListDTOs: rowDataCRUD,
        chkCode1: '',
        dateValid: false,
        insertDate: getDateDayPlus(),
        warehouse: master.warehouse,
        vesselRegNo: '',
        mawbNo: '',
        containerNo: '',
        warehouseValid: false,
      };

      const result = await confirm(apiName, DataCRUD);

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }
      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        unloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          unloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);
        setEnableConfirm(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableConfirm(false);
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            etaDate: node.data.etaDate,
            warehouse: node.data.warehouse,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            declDate: node.data.declDate,
            uploadDate: node.data.uploadDate,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }

      const DataCRUD: ICRUD = {
        unloadGoodsListDTOs: rowDataCRUD,
        chkCode1: '',
        dateValid: false,
        insertDate: master.insertDate,
        warehouse: master.warehouse,
        vesselRegNo: '',
        mawbNo: '',
        containerNo: '',
        warehouseValid: false,
      };
      const result = await deleteItem(apiName, DataCRUD);
      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        unloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          unloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);
        setEnableConfirm(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableConfirm(false);
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUpload = async (
    file: File,
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const formData = new FormData();
      formData.append('execlFile', file);

      const result = await upload(apiName, formData);

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        unloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          unloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(false);
        console.log('setEnableSave', false);
        setEnableConfirm(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableConfirm(false);
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };
  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案

    if (file) {
      handleUpload(file);
    }
    e.target.value = '';
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const result = await postExcel(apiName, {
        insertDate: master.insertDate,
        warehouse: master.warehouse,
        vesselRegNo: master.vesselRegNo,
        mawbNo: master.mawbNo,
        containerNo: master.containerNo,
      });

      blobDownload(
        result,
        enqueueSnackbar,
        `${formatDate(master.insertDate, 'yyyyMMdd')}_貨櫃卸存清單查詢.csv`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.insertDate.length === 0) {
      master.insertDate = getDateDayPlus();
    }
    if (!master.dateValid || !master.warehouseValid) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'confirm':
        handleConfirm();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;
      case 'getSample':
        handleSample();
        break;
      case 'getExcel':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const handleReset = async () => {
    await gridRef.current?.api.stopEditing(true);
    setRamdom(Math.random());
    setMaster(masterDefaultValue);

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setEnableConfirm(false);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setQueryOK(false);
    setEnableSave(false);
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 貨櫃卸存清單維護
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*上傳日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="insertDate"
                data={master}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                貨棧業者：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              海關通關號碼：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                // placeholder="主號或進倉日期區間擇一必填"
                maxLength={35}
                value={master.vesselRegNo}
                name="vesselRegNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              主提單號碼：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={35}
                value={master.mawbNo}
                name="mawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              貨櫃號碼：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={35}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={
                !enableConfirm ||
                formError ||
                isType(userTypeList.type4, userType) ||
                isType(userTypeList.topType, userType)
              }
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              確定
            </Button>
          </VcEGrid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={
                !enableSave ||
                formError ||
                isType(userTypeList.type4, userType) ||
                isType(userTypeList.topType, userType)
              }
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<DeleteForeverIcon />}
              onClick={() => setSubmitKey('deleteItem')}
            >
              刪除
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <input
              disabled={
                !(isType(userTypeList.type2, userType) || isTypeBK(userType)) ||
                formError
              }
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              className={classes.input}
              id="contained-button-file"
              // multiple
              type="file"
              onChange={selectFile}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={
                  !(
                    isType(userTypeList.type2, userType) || isTypeBK(userType)
                  ) || formError
                }
                variant="contained"
                color="default"
                startIcon={<AttachFileIcon />}
                component="span"
                style={{
                  borderRadius: '20px',
                  // backgroundColor: 'blue',
                }}
              >
                上傳EXCEL
              </Button>
            </label>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                (!isType(userTypeList.type1, userType) &&
                  !isType(userTypeList.admin, userType)) ||
                !enableSave ||
                formError
              }
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getExcel')}
            >
              彙總匯出
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                !(isType(userTypeList.type2, userType) || isTypeBK(userType)) ||
                formError
              }
              type="submit"
              variant="outlined"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('getSample')}
            >
              下載EXCEL格式範本
            </Button>
          </Grid>
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          說明：請於上班日16:30前上傳卸存清單!
        </div>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              全選
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              全不選
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default CtnrUnloadListMtn;
